import ApiClient from './ApiClient';

class ProductGroupsAPI extends ApiClient {
  constructor() {
    super('product_groups', { accountScoped: true });
  }
}

export default new ProductGroupsAPI();
